import { Assert, AssertNeedCodeMap, Graph, Options } from '.';
import { cleanResource, writeFileSync } from './utils/utils';

function seal(graph: Graph, options: Options) {
  debugger;
  const { outputFile } = options;
  const assert = graph[0];
  const importCode = assert.importDepNeedCodeMap;
  deleteImport(assert);
  if (!importCode || !importCode.size) {
    write(assert.code, outputFile);
    return true;
  }
  mergeCode(assert);
  write(assert.code, outputFile);
}

function deleteImport(assert: Assert) {
  // const dependence = assert.dependencies;
  // tip: 使用原始的grammer.imports. 因为dependencies可能被tree shake.
  const imports = assert.grammer.imports;
  const code = assert.code;
  if (!imports || !imports.length) return true;
  // tip: 理论上，所有的import都在最顶层
  const offset = imports.slice(-1).pop()!.location.end.offset;
  assert.code = code.slice(offset);
}

function write(code: string, outputFile: string) {
  cleanResource(outputFile);
  const filename = outputFile.split('/').pop();
  const dir = outputFile.split('/').slice(0, -1).join('/');
  writeFileSync(dir, filename!, code);
}

function mergeCode(assert: Assert) {
  const importCode = assert.importDepNeedCodeMap!;
  const ruleCode = assert.ruleCode;
  const codeMap = new Map();
  for (const [key, value] of importCode) {
    if (ruleCode?.has(key)) {
      continue;
    }
    getDepRules(value);
  }
  function getDepRules(ruleMap: AssertNeedCodeMap | null) {
    if (!ruleMap) return;
    for (const [key, value] of ruleMap) {
      if (ruleCode?.has(key)) {
        continue;
      }
      if (codeMap.has(key)) {
        continue;
      }
      codeMap.set(key, value);
    }
  }
  if (!codeMap.size) return true;
  let code = assert.code;
  for (const [key, value] of codeMap) {
    const { code: fragmentCode } = value || {};
    if (!fragmentCode) continue;
    code += '\n' + fragmentCode;
  }
  assert.code = code;
}

export { seal };
